import React from 'react';
import { FaHands, FaGraduationCap, FaHome } from 'react-icons/fa';

const Aims = () => {
  const aimsData = [
    {
      icon: <FaHands />,
      title: "Provision of Needs",
      description: "Provide essential needs to children with autism living in unfavorable environments. We bridge the gap in resources and understanding that hinders these children from reaching their full potential."
    },
    {
      icon: <FaGraduationCap />,
      title: "Better Learning Environment",
      description: "Create supportive learning areas and housing with healthy living criteria. We educate society about autism to eliminate stigma and ensure these children are included in community life."
    },
    {
      icon: <FaHome />,
      title: "Comfortable Housing",
      description: "Provide nurturing homes for isolated children with autism. Our facilities are staffed with caring patrons and matrons who create a supportive environment for growth and development."
    }
  ];

  return (
    <section id="aims" className="aims">
      <div className="container">
        <h2 className="section-title">Our Aims</h2>
        <div className="aims-container">
          {aimsData.map((aim, index) => (
            <div key={index} className="aim-card">
              <div className="aim-icon">
                {aim.icon}
              </div>
              <h3>{aim.title}</h3>
              <p>{aim.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Aims;